/**
 * Device Files Search Schema
 * @description デバイスファイル画面の検索パラメータスキーマ
 */

import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { DEVICE_FILE_PAGE_SIZE, DEVICE_FOLDER_TYPES } from './-constants';
import { DeviceFileSortColumn } from './-query/type';
export const DeviceFilesSearchSchema = z.object({
  folderType: z.enum(DEVICE_FOLDER_TYPES).optional().catch(undefined),
  pageIndex: z.number().int().min(0).default(0),
  pageSize: z.number().int().min(1).max(2000).default(DEVICE_FILE_PAGE_SIZE),
  sortColumn: z.nativeEnum(DeviceFileSortColumn).optional().catch(undefined),
  sortOrder: z.nativeEnum(OrderDirection).optional().catch(undefined)
});